import { useRef, useState, useEffect } from "react";

import cleo from "../../../assets/home_assets/professora Cleo.webp"
import tezei from "../../../assets/home_assets/professor Fábio Tezzei.webp"
import eduardo from "../../../assets/home_assets/professor Eduardo Fonseca .webp"

export default function TeacherRender() {

    //const [expandedRef, setExpandedRef] = useState(null);
    //const [expandedArrow, setExpandedArrow] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(1)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 450);

    const cleoRef = useRef(null)
    const eduardoRef = useRef(null)
    const tezeiRef = useRef(null)


    const teacherCard = [
        {
            nome: "Cléo Tezzei",
            card: cleo,
            referencia: cleoRef,
            //arrowRef: arrowCleoRef
        },

        {
            nome: "Eduardo Fonseca",
            card: eduardo,
            referencia: eduardoRef,
            //arrowRef: arrowEduardoRef
        },

        {
            nome: "fábio Tezzei",
            card: tezei,
            referencia: tezeiRef,
            //arrowRef: arrowTezeiRef
        },

    ]

    const showCard = (index) => {
        setCurrentIndex(index);
    };


    function nextImg() {
        const newIndex = (currentIndex + 1) % teacherCard.length
        showCard(newIndex);

    }

    function prevImg() {
        const newIndex = (currentIndex - 1 + teacherCard.length) % teacherCard.length
        showCard(newIndex);
    }

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 450);
        };

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);


    //const expandTeacher = (ref, arrowRef) => {
    //    if (!ref?.current || !arrowRef?.current) return;
    //
    //    const isSame = ref.current === expandedRef?.current;
    //
    //    if (isSame) {
    //        ref.current.classList.remove("expand");
    //        arrowRef.current.className = "bi bi-box-arrow-up-right";
    //        setExpandedRef(null);
    //        setExpandedArrow(null);
    //
    //
    //    } else {
    //        if (expandedRef?.current && expandedArrow?.current) {
    //            expandedRef.current.classList.remove("expand");
    //            expandedArrow.current.className = "bi bi-box-arrow-up-right";
    //        }
    //
    //
    //        ref.current.classList.add("expand");
    //        arrowRef.current.className = "bi bi-box-arrow-down-left";
    //        setExpandedRef(ref);
    //        setExpandedArrow(arrowRef);
    //    }
    //
    //
    //}
    return (
        <>


            {isMobile ? (

                <div className="main_teachers">
                    {teacherCard.map((teacher, index) => (

                        <div key={index} ref={(el) => teacher.referencia = el} className={`teacher_card ${index === currentIndex ? "active" : ""}`}>



                            <i onClick={prevImg} id="teacher-img_left" class="bi bi-chevron-left"></i>
                            <i onClick={nextImg} id="teacher-img_right" class="bi bi-chevron-right"></i>
                            <img src={teacher.card} alt="Imagem Professor Team Crezio" loading="lazy"></img>
                            <ul className="card_text">
                                <li>Formado em tal lugar</li>
                            </ul>
                            <p className="teacher_card_name">{teacher.nome}</p>

                        </div>

                    ))}
                </div>

            ) : (
                <div className="main_teachers">
                    {teacherCard.map((teacher) => (
                        <div ref={teacher.referencia} className="teacher_card">

                            <img src={teacher.card} alt="Imagem Professor Team Crezio" loading="lazy"></img>
                            <ul className="card_text">
                                <li>Formado em tal lugar</li>
                            </ul>
                            <p className="teacher_card_name">{teacher.nome}</p>


                        </div>
                    ))}
                </div>
            )}



        </>
    )

}